import React, { FC, forwardRef, MouseEvent } from 'react';
import { ReactComponent as SearchIcon } from '../../../icons/search.svg';
import { StyledIcon } from './SearchInput.styles';
import TextInput, { TextInputProps } from '../TextInput';
import useTranslation from '../../../hooks/useTranslation';

export interface SearchInputProps extends TextInputProps {
  /** Callback when the search button is clicked */
  onSearch?: (event: MouseEvent<HTMLButtonElement>) => void;
  /** Use a button of primary color */
  buttonPrimaryBackground?: boolean;
}

/**
 * @mode developer
 */
const SearchInput = Object.assign(
  forwardRef<HTMLInputElement, SearchInputProps>(({ onSearch, buttonPrimaryBackground, ...props }, ref) => {
    const { t } = useTranslation('Core.SearchInput');
    return (
      <TextInput
        clickableRightSign
        rightSign={(
          <StyledIcon
            Icon={SearchIcon}
            onClick={onSearch}
            aria-label={t('search')}
            label={t('search')}
            buttonSize={40}
            primaryBackground={buttonPrimaryBackground}
          />
        )}
        {...props}
        ref={ref}
      />
    );
  }) as FC<SearchInputProps>,
  {
    labeledControl: true,
  },
);

export default SearchInput;
